import React from 'react';
import { Button } from 'react-bootstrap';
import { IoDocumentTextOutline } from 'react-icons/io5';

const ExportButton = ({ onClick, size, noMargin }) => {
  return (
    <Button
      size={size}
      variant="outline-success"
      onClick={onClick}
      className={`mx-1 ${noMargin ? 'm-0' : 'mb-1'}`}
    >
      <IoDocumentTextOutline size={18} />
      <span className="ml-2 text-uppercase">Export</span>
    </Button>
  );
};

export default ExportButton;
